import { notifications as notifApi } from '../api.js';
import { navigate } from '../utils/router.js';
import { esc, avatarUrl, formatTime, toast } from '../utils/dom.js';

const TYPE_LABEL = {
  like: '赞了你的帖子',
  comment: '评论了你的帖子',
  follow: '关注了你',
  message: '给你发了私信',
  broadcast: '系统广播',
};

export async function renderNotifications(container, { onRead } = {}) {
  container.innerHTML = `<div class="center-box"><div class="spinner"></div></div>`;
  try {
    const data = await notifApi.list({ limit: 50 });
    const items = data.items || [];
    const unread = data.unread ?? items.filter((n) => !n.is_read).length;

    if (!items.length) {
      container.innerHTML = `<div class="empty-state"><div>🔔</div><p>暂无提醒</p></div>`;
      onRead?.(0);
      return;
    }

    const header = document.createElement('div');
    header.className = 'flex justify-between items-center';
    header.style.padding = '0.75rem 1.1rem';
    header.style.borderBottom = '1px solid var(--border)';
    header.innerHTML = `
      <span class="text-sm muted">${unread ? `${unread} 条未读` : '全部已读'}</span>
      <button type="button" class="btn btn-ghost btn-sm" id="mark-all-read">全部标为已读</button>
    `;
    container.innerHTML = '';
    container.appendChild(header);

    header.querySelector('#mark-all-read')?.addEventListener('click', async () => {
      try {
        await notifApi.markRead();
        toast('已全部标为已读', 'success');
        onRead?.(0);
        renderNotifications(container, { onRead });
      } catch (err) {
        toast(err.message || '操作失败', 'error');
      }
    });

    items.forEach((n) => {
      const from = n.from_user || {};
      const row = document.createElement('div');
      row.className = `notif-item ${n.is_read ? '' : 'unread'}`;
      const isBroadcast = n.type === 'broadcast';
      const label = isBroadcast
        ? n.message || TYPE_LABEL.broadcast
        : TYPE_LABEL[n.type] || n.message || n.type || '通知';
      row.innerHTML = `
        <img src="${esc(
          isBroadcast ? avatarUrl({ nickname: 'GS', gid: 'sys' }) : avatarUrl(from)
        )}" alt="" />
        <div style="flex:1;min-width:0">
          <div>
            ${
              isBroadcast
                ? `<strong>系统广播</strong><div class="text-sm" style="margin-top:0.25rem;white-space:pre-wrap">${esc(
                    n.message || ''
                  )}</div>`
                : `<strong>${esc(from.nickname || '有人')}</strong>
            <span class="muted"> ${esc(label)}</span>
            ${n.message && n.type === 'comment' ? `<div class="text-sm muted" style="margin-top:0.2rem">${esc(n.message)}</div>` : ''}`
            }
          </div>
          <div class="text-xs faint">${esc(formatTime(n.created_at))}</div>
        </div>
      `;
      row.addEventListener('click', async () => {
        try {
          if (!n.is_read) await notifApi.markRead([n.id]);
        } catch {
          /* ignore */
        }
        if (n.post_id) navigate(`/post/${n.post_id}`);
        else if (!isBroadcast && from.gid) navigate(`/user/${from.gid}`);
        onRead?.();
      });
      container.appendChild(row);
    });

    onRead?.(unread);
  } catch (err) {
    container.innerHTML = `<div class="empty-state"><p style="color:var(--danger)">${esc(
      err.message || '加载失败'
    )}</p></div>`;
  }
}

export async function fetchUnreadCount() {
  try {
    const data = await notifApi.list({ limit: 1 });
    return data.unread ?? 0;
  } catch {
    return 0;
  }
}
